import React, { Component } from 'react';
import { Field, reduxForm  } from 'redux-form';
import { validate, renderField } from './PasswordValidationSchema';

import Button from './../Elements/Button.js';

class ForgotPasswordForm extends Component {  
  render() {
    const { handleSubmit, submitting, error, valid } = this.props;

    return (
      <form onSubmit={handleSubmit} className="login-form" autoComplete="off">
        <h2 className="font-weight-bold">Reset your password.</h2>

        <div className="form-msg-1 mt-4 mb-5">
          Sorry you are having trouble logging in. We will send a temporary password to the email account listed below.
        </div>
        
        { error && error !== "success"
          ? <div className="alert alert-danger">{error}</div>
          : null
        }
        { error && error === "success"
          ? <div className="alert alert-success">Password reset link was sent to your email.</div>
          : null
        }

        <div className="form-group">
          <div className="">
            <Field
              name="email"
              type="email"
              className="form-control form-control-lg"
              placeholder="email"
              component={renderField}
            />
          </div>
        </div>

        <div className="form-group d-flex justify-content-end align-items-baseline">
          <a href="/login" className="forgot-password-link mr-5">cancel</a>
          <Button
            color="primary"
            float="right"
            className="btn btn-lg mt-3 btn-submit"
            disabled={submitting || !valid}
            onClick={handleSubmit}>
            SEND
          </Button>
        </div>

        <div className="form-msg-2">
          If you no longer have access to that account, please <b><a href="mailto:andrew@pickaxe.ai">contact us</a></b> for additional support.
        </div>
      </form>
    );
  }
}

export default reduxForm({ 
  form: 'forgot_password',
  validate
})(ForgotPasswordForm);
